import React, { ReactNode } from 'react'
import { ContentBlock, ContentState } from 'draft-js'
import { EditorPlugin } from '@draft-js-plugins/editor'
import SmartLink from '../components/SmartLink'

interface LinkProps {
  contentState: ContentState
  entityKey: string
  children: ReactNode
}

export const createAnchorPlugin = (): EditorPlugin => {
  const findLinkEntities = (
    contentBlock: ContentBlock,
    callback: (start: number, end: number) => void,
    contentState: ContentState
  ) => {
    contentBlock.findEntityRanges((character) => {
      const entityKey = character.getEntity()
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK'
    }, callback)
  }

  const Link = (props: LinkProps) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData()

    return <SmartLink href={url}>{props.children}</SmartLink>
  }
  return {
    decorators: [
      {
        strategy: findLinkEntities,
        component: Link
      }
    ]
  }
}

export default createAnchorPlugin
